<template>
  <div class="wechat-chat">
    <div class="chat-log" ref="chatLog">
      <div class="chat-welcome">
        <div class="welcome-text">
          你好，我是您的人工智能助理Magic！我可以回答你的问题，为你提供有用信息，帮你完成创作。
        </div>
        <div class="warning">
          友情提醒：提问时请遵循法律法规，一切产生的不良后果自行承担。
        </div>
      </div>
      <div v-for="(message, index) in messages" :key="index" :class="message.type">
        <div class="message-container">
          <img v-if="message.type === 'incoming'" :src="human" class="icon-img">
          <img v-else :src="assistant" class="icon-img">
          <span class="message-text">{{ message.content }}</span>
        </div>
      </div>
    </div>
    <div class="chat-input">
      <input v-model="question" placeholder="输入消息..." @keyup.enter="sendMessage">
      <button @click="sendMessage">发送</button>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js';
import human from '@/assets/human3.png';
import assistant from '@/assets/assistant.png';

const APPID = '57e2f3f2'; // 请替换为实际的APPID
const API_SECRET = 'MzI2M2M3NmI4ZDMzNTg5MDZjNjllZjZk'; // 请替换为实际的API_SECRET
const API_KEY = '784d9aaaefdb091bdf33a89483fe8cb5'; // 请替换为实际的API_KEY

export default {
  name: 'ChatBox',
  data() {
    return {
      question: '',
      messages: [],
      modelDomain: 'generalv3.5',
      httpUrl: new URL("https://spark-api.xf-yun.com/v3.5/chat"),
      currentAnswer: '',
      human: human,
      assistant: assistant
    };
  },
  methods: {
    sendMessage() {
      this.currentAnswer = '';
      this.getWebsocketUrl().then(url => {
        const params = {
          header: {
            app_id: APPID, uid: 'fd3f47e4-d'
          },
          parameter: {
            chat: {
              domain: this.modelDomain, temperature: 0.5, max_tokens: 1024
            }
          },
          payload: {
            message: {
              text: [
                { role: 'user', content: this.question }
              ]
            }
          }
        };
        const ttsWS = new WebSocket(url);
        ttsWS.onopen = () => {
          ttsWS.send(JSON.stringify(params));
          const message = {
            content: this.question,
            type: 'incoming'
          };
          this.messages.push(message);
        };
        ttsWS.onmessage = (e) => {
          this.handleResult(e.data);
        };
        ttsWS.onerror = (e) => {
          console.error(`WebSocket报错，请f12查看详情`);
          console.error(`详情查看：${encodeURI(url.replace('wss:', 'https:'))}`);
        };
        ttsWS.onclose = (e) => {
          console.log(e);
        };
      });
    },
    getWebsocketUrl() {
      return new Promise((resolve, reject) => {
        const apiKey = API_KEY;
        const apiSecret = API_SECRET;
        const host = location.host;
        const date = new Date().toGMTString();
        const algorithm = 'hmac-sha256';
        const headers = 'host date request-line';
        const signatureOrigin = `host: ${host}\ndate: ${date}\nGET ${this.httpUrl.pathname} HTTP/1.1`;
        const signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret);
        const signature = CryptoJS.enc.Base64.stringify(signatureSha);
        const authorizationOrigin = `api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`;
        const authorization = btoa(authorizationOrigin);
        const url = `${this.httpUrl.origin}${this.httpUrl.pathname}?authorization=${authorization}&date=${date}&host=${host}`;
        resolve(url);
      });
    },
    handleResult(resultData) {
      let jsonData = JSON.parse(resultData);
      if (jsonData.header.code !== 0) {
        alert(`提问失败: ${jsonData.header.code}:${jsonData.header.message}`);
        console.error(`${jsonData.header.code}:${jsonData.header.message}`);
      }
      if (jsonData.header.code === 0) {
        if (jsonData.payload.choices.status === 0) {
          const message = {
            content: '',
            type: 'outgoing'
          };
          this.messages.push(message);
        }
        this.currentAnswer += jsonData.payload.choices.text[0].content;
        this.messages[this.messages.length - 1].content = this.currentAnswer; // 更新答案
        if (jsonData.payload.choices.status === 2) {
          this.question = '';
        }
        console.log(this.currentAnswer)
        console.log(this.messages)
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        this.$refs.chatLog.scrollTop = this.$refs.chatLog.scrollHeight;
      });
    }
  },
   watch: {
    // 监听messages的变化，确保每次变化后都滚动到底部
    messages: {
      deep: true,
      handler() {
        this.scrollToBottom();
      }
    }
  }
};
</script>

<style scoped>
.wechat-chat {
  max-width: 70vw;
  height: 60vh;
  margin: 50px auto;
  border: 1px solid #ccc;
  border-radius: 5px;
  overflow: hidden;
}

.chat-log {
  height: calc(100% - 70px);
  overflow-y: auto;
  padding: 10px;
}

.warning{
  color: #924df9;
}

.chat-input {
  display: flex;
  padding: 10px;
}

.message-container {
  display: flex; /* 使用 Flexbox 实现水平排列 */
  align-items: center; /* 垂直居中对齐 */
}

.icon-img {
  width: 24px; /* 图标宽度 */
  height: 24px; /* 图标高度 */
  margin-right: 8px; /* 图标与文本之间的间距 */
}

.incoming {
  text-align: left;
}

.incoming .message-container {
  background-color: #34344c61;
}

.outgoing {
  text-align: left;
}

.outgoing .message-container {
  background-color: #36362a;
}

.message-text {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 5px;
  margin-top: 5px;
  color: white;
}

input {
  flex-grow: 1;
  margin-right: 10px;
}

button {
  padding: 5px 10px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>